import {Injectable} from '@angular/core';
import {NbAuthService} from '@nebular/auth';
import {BodyOutputType, Toast, ToasterConfig, ToasterService} from 'angular2-toaster';
import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import { environment} from '../../../environments/environment';

// import {stringify} from 'querystring';


@Injectable()
export class MessageService {
  private url = environment.sailsBackendUrl;
  protected socket: io.SocketIOClient.Socket;


  constructor( private authService: NbAuthService,
               private toasterService: ToasterService,
  ) {

    this.authService.onTokenChange()
      .subscribe((token) => {

          if ( token != null ) {
              this.socket = io(this.url, {query: '&session_id=' + token.getValue()});
          }else {
              // Disconnect socket when a token change occures with NULL token
              this.socket.disconnect();
          }

      });

    this.socket.on('noHostIsJoined',  (data) => {
      this.showToast('warning', 'Gateway is offline', 'Check the gateway connectivity');
    });

    this.socket.on('hostHasLeft',  (data) => {
      this.showToast('warning', 'Connection lost to gateway', 'Check the gateway connectivity');
    });

    this.socket.on('hostHasJoined',  (data) => {
      this.showToast('success', 'Gateway is connected', '');
    });

  }

  public syncAllWidgets() {
    this.socket.emit('getAllDevices');
  }

  public getAllDevices() {

      return new Observable(observer => {

          this.socket.on('showAllDevices', (data) => {

              observer.next(data);
          });

          this.socket.emit('getAllDevices');

      });

  };

  public getGatewayPhisicalDevices(callback) {
      this.socket.emit('getGatewayDevices', [], callback);
  }

  public getElectricityConsumption(options, callback) {
      this.socket.emit('getElectricityConsumption', options, callback);
  }

  public getChartSubscription(device, xTime, yValue, valueCallback) {

        if (valueCallback === undefined) {
            valueCallback = function(data){return data};
        }

        return new Observable(observer => {

            this.socket.on('showChartHistoryData', (data) => {

                if (data.device.vendor === device.vendor &&
                    data.device.deviceType === device.deviceType &&
                    data.device.deviceId === device.deviceId) {

                    observer.next(data.content.map(obj => {

                        // console.log(obj[xTime]);

                        return [
                            Math.floor((new Date(obj[xTime])).getTime() + 2 * 60 * 60 * 1000), // Last 2 days
                            parseFloat(valueCallback(obj[yValue])),
                            // device.identifier === 'biodom_thermostat_relay' ?
                            //     (obj.value > 0 ? 25 : 0) : parseFloat(obj.value),
                        ];

                    }));
                }
            });

            // When subscribed, trigger send Chart history
            this.socket.emit('getChartHistory', device);
        });
    }


  public getSubscription(vendor: string, deviceType: number, deviceId: string, componentId?: string) {
    return new Observable(observer => {

      this.socket.on('GATEWAY_TO_REMOTE_HOST', (data) => {

          // console.log('messageService | GATEWAY_TO_REMOTE_HOST: ' + JSON.stringify(data));

          if (data.deviceId.toString() === deviceId &&
              parseInt(data.deviceType, 10) === deviceType &&
              data.vendor.toString() === vendor &&
              data.componentId === componentId) {

            observer.next(data);
          }
      });

      // When subscribed, send first value from database
      this.socket.emit('getDataFromDb', {
          'vendor': vendor,
          'deviceType': deviceType,
          'deviceId': deviceId,
          'componentId': componentId,
      });

    });
  }

    public saveWidget(name, data) {
        // console.log('Saving widget: ' + name + ' widget with data: ' + JSON.stringify(data));

        this.socket.emit('saveWidget', {type: name, data: data});
    }

  public setWidgetConfig(data: object) {
      this.socket.emit('setWidgetConfig', data);
  }

  public removeWidget(name, id) {
      this.socket.emit('removeWidget', {type: name, id: id});
  }


  public sendDataToGateway(data, cback) {

      const self = this;

      this.socket.emit('sendDataToGateway', data, function(confirmation){

          if (confirmation.success) {
              self.showToast('info', 'Gateway confirmed', confirmation.message);
          }else {
              self.showToast('warning', 'Gateway declined', confirmation.message);
          }
          // Return true if data processed correctly on GW
          cback(confirmation.success);
      });
  }

   // TOASTER
  config: ToasterConfig;
  position = 'toast-top-right';
  animationType = 'fade';
  timeout = 5000;
  toastsLimit = 5;
  type = 'default';
  isNewestOnTop = true;
  isHideOnClick = true;
  isDuplicatesPrevented = false;
  isCloseButton = true;

  showToast(type: string, title: string, body: string) {
    this.config = new ToasterConfig({
      positionClass: this.position,
      timeout: this.timeout,
      newestOnTop: this.isNewestOnTop,
      tapToDismiss: this.isHideOnClick,
      preventDuplicates: this.isDuplicatesPrevented,
      animation: this.animationType,
      limit: this.toastsLimit,
    });
    const toast: Toast = {
      type: type,
      title: title,
      body: body,
      timeout: this.timeout,
      showCloseButton: this.isCloseButton,
      bodyOutputType: BodyOutputType.TrustedHtml,
    };
    this.toasterService.popAsync(toast);
  }

  clearToasts() {
    this.toasterService.clear();
  }
}



// WEBPACK FOOTER //
// /app/src/app/@core/services/message.service.ts